<template>
  <v-menu :close-on-content-click="false" max-width="320" offset-x>
    <template v-slot:activator="{ on }">
      <FilterBottom v-on="on" />
    </template>

    <v-card>
      <v-container>
        <v-switch
          v-model="filters.ativo"
          true-value="S"
          false-value="N"
          label="Ativo"
          @change="handleFilter()"
        ></v-switch>
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Segmento"
          item-text="descricao"
          item-value="id_band"
          service="sistemaService.tipoBandeiras"
          v-model="filters.id_band"
          :isCompany="true"
          @change="handleFilter()"
        />
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Tipo Meta"
          item-text="tipo_meta"
          item-value="id_tipo_meta"
          service="campanhaService.tipoMeta"
          v-model="filters.id_tipo_meta"
          @change="handleFilter()"
        />
        <BaseFilter
          label="Função"
          service="sistemaService.funcoes"
          v-model="filters.id_funcao"
          item-text="descricao"
          item-value="id_funcao"
          prepend-inner-icon="mdi-account-tie"
          clearable
          single-line
          :hasCode="true"
          :filters="{
            ativo: 'S'
          }"
          @change="handleFilter()"
        />
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import FilterBottom from "@/components/shared/bottons/FilterBottom";
import BaseFilter from "@/components/shared/BaseSelectService";
export default {
  name: "FilterComissao",

  components: {
    BaseFilter,
    FilterBottom
  },

  data() {
    return {
      filters: {
        ativo: "S"
      }
    };
  },

  methods: {
    handleFilter() {
      this.$emit("selectedFilters", this.filters);
    }
  }
};
</script>
